// extracted by mini-css-extract-plugin
module.exports = {"containerReportButton":"ReportButton_containerReportButton__Oa2Kd","icon":"ReportButton_icon__1eOic","link":"ReportButton_link__2_ph8"};